
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ChartBar, File, ListFilter } from "lucide-react";

export const QuickActions = () => {
  return (
    <Card className="md:w-1/3">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center text-lg">
          <ChartBar className="mr-2 h-5 w-5 text-nation-blue" />
          Quick Actions
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <Button 
            className="w-full justify-start"
            asChild
          >
            <Link to="/dashboard/polls">
              <ListFilter className="mr-2 h-4 w-4" />
              View Available Polls
            </Link>
          </Button>
          
          <Button 
            variant="outline" 
            className="w-full justify-start"
            asChild
          >
            <Link to="/profile">
              <File className="mr-2 h-4 w-4" />
              Manage My Profile
            </Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
